// The top bar's avatar (Mohammed 04/10/2026): the user's initials in a circle.
// First and last name when the profile has them, else the words of fullName, else the email.
export function initialsFor(profile) {
  const p = profile || {}
  const first = String(p.firstName || '').trim()
  const last = String(p.lastName || '').trim()
  if (first || last) return ((first[0] || '') + (last[0] || '')).toUpperCase()
  const words = String(p.fullName || '').trim().split(/\s+/).filter(Boolean)
  if (words.length) return ((words[0][0] || '') + (words.length > 1 ? words[words.length - 1][0] : '')).toUpperCase()
  const email = String(p.email || '').trim()
  return email ? email[0].toUpperCase() : '?'
}
